import fourPoolSwapAbi from './json/3pool/swap';
import fusdtSwap from './json/fusdt/swap';
import fusdtDeposit from './json/fusdt/deposit';
import renSwapABI from './json/ren/swap';
import daiSwap from './json/dai/swap';
import daiDeposit from './json/dai/deposit';


const multicall_address = '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb';

const poolsData = {
    '3pool': {
        swap_abi: fourPoolSwapAbi,
        N_COINS: 3,
        coin_precisions: [1e18, 1e18, 1e18],
        wrapped_precisions: [1e18, 1e18, 1e18],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0x160CAed03795365F3A589f10C379FfA7d75d4E76',
        token_address: '0xaF4dE8E872131AE328Ce21D909C74705d3Aaf452',
        gauge_address: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        underlying_coins: [
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
        coins: [
          '0xe9e7cea3dedca5984780bafc599bd69add087d56',
          '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
          '0x55d398326f99059ff775485246999027b3197955',
        ],
    },
    fusdt: {
        N_COINS: 2,
        coin_precisions: [1e6, 1e18],
        wrapped_precisions: [1e6, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x556ea0b4c06D043806859c9490072FaadC104b63',
        token_address: '0x373410A99B64B089DFE16F1088526D399252dacE',
        gauge_address: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        underlying_coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        ],
        coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        ],
        swap_abi: fusdtSwap,
        deposit_abi: fusdtDeposit,
        deposit_address: '0xf17814d515d3128753befd56cCeCEC2a0A41015F',
        is_meta: true,
        base_pool: '3pool',
        meta_N: 5,
        meta_precisions: [1e6, 1e18, 1e18, 1e18, 1e18],
        meta_coin_precisions: [1e6, 1e18, 1e18, 1e18],
        meta_wrapped_precisions: [1e6, 1e18],
        meta_coins: [
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
        all_coins: [
            '0x049d68029688eabf473097a2fc38ef61633a3c7a',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
    },
    ren: {
        N_COINS: 2,
        coin_precisions: [1e18, 1e8],
        wrapped_precisions: [1e18, 1e8],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x2477fB288c5b4118315714ad3c7Fd7CC69b00bf9',
        token_address: '0x2a435Ecb3fcC0E316492Dc1cdd62d0F189be5640',
        gauge_address: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        underlying_coins: [
            '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
            '0xfce146bf3146100cfe5db4129cf6c82b0ef4ad8c',
        ],
        coins: [
            '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
            '0xfce146bf3146100cfe5db4129cf6c82b0ef4ad8c',
        ],
        swap_abi: renSwapABI,
    },
    dai: {
        N_COINS: 2,
        coin_precisions: [1e18, 1e18],
        wrapped_precisions: [1e18, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0xc6a752948627bECaB5474a10821Df73fF4771a49',
        token_address: '0x0BC3a8239B0a63E945Ea1bd6722Ba747b9557e56',
        gauge_address: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        underlying_coins: [
            '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        ],
        coins: [
            '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        ],
        swap_abi: daiSwap,
        deposit_abi: daiDeposit,
        deposit_address: '0x2D0A931Dd088ea108a73901f83065DCA81ca474C',
        is_meta: true,
        base_pool: '3pool',
        meta_N: 5,
        meta_precisions: [1e18, 1e18, 1e18, 1e18, 1e18],
        meta_coin_precisions: [1e18, 1e18, 1e18, 1e18],
        meta_wrapped_precisions: [1e18, 1e18],
        meta_coins: [
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
        all_coins: [
            '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
    },
    tusd: {
        N_COINS: 2,
        coin_precisions: [1e18, 1e18],
        wrapped_precisions: [1e18, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x8D7408C2b3154F9f97fc6dd24cd36143908d1E52',
        token_address: '0x052E566a25ACE8934Dcc52c41A27b04a7C7ECCbE',
        gauge_address: '0xb5eb451137e90435449f4EB5680C404a355887a1',
        underlying_coins: [
            '0x14016E85a25aeb13065688cAFB43044C2ef86784',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        ],
        coins: [
            '0x14016E85a25aeb13065688cAFB43044C2ef86784',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        ],
        swap_abi: daiSwap,
        deposit_abi: daiDeposit,
        deposit_address: '0xB4c0A71bFa5a5a4b1A096A7addb5025eAfAdA122',
        is_meta: true,
        base_pool: '3pool',
        meta_N: 5,
        meta_precisions: [1e18, 1e18, 1e18, 1e18, 1e18],
        meta_coin_precisions: [1e18, 1e18, 1e18, 1e18],
        meta_wrapped_precisions: [1e18, 1e18],
        meta_coins: [
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
        all_coins: [
            '0x14016E85a25aeb13065688cAFB43044C2ef86784',
            '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
            '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            '0x55d398326f99059ff775485246999027b3197955',
        ],
    },

};

export {
    multicall_address,
    poolsData,
};
